import { render } from "./carrusel.vue?vue&type=template&id=23f9363a"
import script from "./carrusel.vue?vue&type=script&lang=js"
export * from "./carrusel.vue?vue&type=script&lang=js"

import "./carrusel.vue?vue&type=style&index=0&id=23f9363a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__